import { Component, OnInit, Optional, Inject } from '@angular/core';
import { ModPreloginService } from '../../services/modprelogin-service.service';
import { PershingTranslationService } from '@pershing/pershing-core';
import { MarketIndicesDialogueComponent } from './market-indices-dialogue.compoenet';
import { MatDialog } from '@angular/material/dialog';
import { PershingDecimalFormatPipe } from '@pershing/pershing-core';
@Component({
  selector: 'mod-indices',
  templateUrl: './market-indices.component.html',
  styleUrls: ['./market-indices.component.css']
})
export class MarketIndicesComponent implements OnInit {

  public dataBlock: any [] = new Array();
  public title: String;
  public summary: String;
  public imageUrl: String;
  public cdnUrl: String;
  public cdnVersion: String;
  public chartUrl: String;
  public timeStamp: String;
  public holdingsTemplate: String;
  private appSettings: any;
  private urlPath: String;
  private data: any;
  public displayInDialogue: boolean;

  constructor(
    private modPreloginService: ModPreloginService,
    private translationService: PershingTranslationService,
    private marketIndicesDialog: MatDialog,
    public pershingDecimalFormatingPipe: PershingDecimalFormatPipe,
    @Optional() @Inject('AppSettings') appSettings: any
    ) {
        this.appSettings = appSettings;
        let parsemap = appSettings.ibdConfigMap;
        if (appSettings.deviceType !== 'desktop') {
          this.displayInDialogue = true;
        } else {
          this.displayInDialogue = false;
        }
        if (parsemap.generic) {
            this.urlPath = parsemap.cdnURL + '/pershing.netxinvestor.brands/' + parsemap.brands_version + '/themes/' + parsemap.themeName + '/images/';
        } else {
            this.urlPath = parsemap.cdnURL + '/pershing.netxinvestor.brands/' + parsemap.brands_version + '/themes/' + parsemap.themeName +
            '/brand/' + parsemap.cssBrand + '/images/';
        }
        this.translationService.addTranslationFolder('@pershing/nxi-ng-mod', 'node_modules/@pershing/nxi-ng-mod/lib');

      }

  ngOnInit() {
        this.getModResponse();
  }

  getModResponse() {
    this.modPreloginService.getModMarketIndicesRespose(this.appSettings.ibdConfigMap.modApiUrl).subscribe(
      resp => {
        let response: any[] = resp;
        this.chartUrl = response['ChartSprite'];
        let holdingsResponse = response['Holdings'];

        for (let indvBlocks in holdingsResponse) {
            if (holdingsResponse.hasOwnProperty(indvBlocks)) {
                holdingsResponse[indvBlocks].Symbol = (holdingsResponse[indvBlocks].Symbol === '&DJI') ? 'DJI' : (holdingsResponse[indvBlocks].Symbol === 'COMP IDX') ? 'COMP.IDX': holdingsResponse[indvBlocks].Symbol;
                holdingsResponse[indvBlocks].ChangeStyle = (holdingsResponse[indvBlocks].PriceChange1Day > 0) ? 'gain' : 'loss';
                this.dataBlock.push(holdingsResponse[indvBlocks]);
                if (holdingsResponse[indvBlocks].Index === holdingsResponse['length'] - 1 ) {
                    this.timeStamp = holdingsResponse[indvBlocks].Timestamp;
                }
            }
          }
        this.imageUrl = this.urlPath + 'icon_marketIndices.png';
        if (this.displayInDialogue) {
          this.data = {
            'chartUrl': this.chartUrl,
            'dataBlock': this.dataBlock,
            'timeStamp': this.timeStamp,
            'imageUrl': this.imageUrl
            };
        }
      }
    );
  }
  openMKTDialogue() {
    this.marketIndicesDialog.open(MarketIndicesDialogueComponent, {data : this.data, panelClass: ['modal', 'ag-Group_Modal']});
  }

}
